import choiceService from './choiceService';

export const getReservations = async () => {
    try {
        const url = `/v1.0/me/reservation`;
        const res = await choiceService.get(url);
        return (res.data);
    } catch (error) {
        console.error(" error trying to getReservations");
        return (undefined);
    }
}

export const createReservation = async (reservation) => {
    try {
        const url = `/v1.0/me/reservation/`;
        const res = await choiceService.post(url, reservation);
        const newReservation = res.data;
        return (newReservation);
    } catch (error) {
        console.error(" error trying to createReservation", error);
        return (undefined);
    }
}

export const saveReservation = async (reservation) => {
    try {
        const url = `/v1.0/me/reservation/${reservation.id}`;
        const res = await choiceService.put(url, reservation);
        const updatedReservation = res.data;
        return (updatedReservation);
    } catch (error) {
        console.error(" error trying to saveReservation", error);
        return (undefined);
    }
}

export const deleteReservation = async (reservation) => null;
